import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ISearchCountModel } from '@apps-common/types/general'

export const QUERY_KEY_SEARCH_MY_MONITORING_ACCOUNTS_COUNT = (search?: string, take?: number) =>
  ['searchMyMonitoringAccountsCount', search].filter(Boolean)

export const searchMyMonitoringAccountsCount = async (search?: string): Promise<ISearchCountModel> =>
  axios.get(`/MyMonitoringAccountManagement/SearchAccountsCount?search=${search || ''}`).then((res) => res.data?.data)

type QueryFnType = typeof searchMyMonitoringAccountsCount

type Props = {
  config?: QueryConfig<QueryFnType>
  search?: string
  take: number
}

export const useSearchMyMonitoringAccountsCount = ({ config, search, take }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_SEARCH_MY_MONITORING_ACCOUNTS_COUNT(search, take),
    queryFn: () => searchMyMonitoringAccountsCount(search)
  })
